<template>
  <div class="article section">
    <BreadCreamVue :data="BreadCreamData" />
    <h1 class="article-title" v-text="data.topic"></h1>
    <div class="publish-time" v-text="data.publish_time"></div>
    <div
      v-if="data.content"
      class="article-content"
      v-html="data.content"
    ></div>
    <div v-if="data.document_url" style="margin-bottom: 80px">
      <iframe
        :src="data.document_url"
        frameborder="0"
        width="100%"
        height="1190"
        style="margin: 0 auto; display: block"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";
import BreadCreamVue from "../../components/BreadCream.vue";
import { useFetchItem } from "../../hooks/fetch-item";
import { api } from "../../utils/apis";
export default defineComponent({
  name: "Article",
  components: {
    BreadCreamVue,
  },
  setup(props, ctx) {
    const routeName = ctx.root.$route.name;
    const id = ctx.root.$route.params.id;
    // 根据路由的名称来判断不同的资源
    // 页面公用数据配置

    const types = {
      "news-detail": {
        // 请求接口
        api: `${api.news.detail}${id}`,
        // 面包屑数据
        bread: {
          title: "NEWS",
          to: "/news",
        },
      },
      "research-detail": {
        api: `${api.research.detail}${id}`,
        bread: {
          title: "RESEARCH",
          to: "/research",
        },
      },
      "events-detail": {
        api: `${api.events.detail}${id}`,
        bread: {
          title: "EVENTS",
          to: "/events",
        },
      },
    };

    const { data } = useFetchItem({ api: types[routeName].api });
    const BreadCreamData = computed(() => {
      return [
        types[routeName]["bread"],
        {
          title: data.value.topic,
          to: "",
        },
      ];
    });

    return { data, BreadCreamData };
  },
});
</script>
<style lang="scss">
.article {
  overflow: hidden;
  .article-title {
    font-size: 22px;
    font-weight: 600;
    color: #231916;
    line-height: 30px;
    text-align: center;
    margin: 40px 40px 20px;
    overflow: hidden;
  }
  .publish-time {
    text-align: center;
    font-size: 14px;
    color: #666;
    line-height: 2;
    margin-bottom: 30px;
  }
  .article-content {
    font-size: 14px;
    line-height: 1.8em;
    padding-bottom: 50px;
    p {
      margin-bottom: 1em;
    }
    img {
      margin: 0 auto;
      display: block;
    }
  }
}
</style>
